import { useContext } from 'react';
import { CentralProviderContext, CentralProviderState } from '@michelin/central-provider';

export const useUFOPaths = () => {
  const { selectedGrant, selectedGrantLocation } = useContext<CentralProviderState>(CentralProviderContext);

  const tenantId = selectedGrant?.id ?? '';
  const grantType = selectedGrant?.grant_location_type ?? '';
  const customerNumber = selectedGrantLocation?.customer_number ?? '';

  return {
    API_PATH_GET_DEFAULTS_CONTACTS:
      grantType === 'dealer' ? `dealers/${tenantId}/contacts` : `fleets/${tenantId}/contacts`,

    PATH_ORDER_LIST: '/:customer_id/orders',
    HOME_PATH: '/:customer_id',
    PATH_ORDER_LIST_TO: `/${customerNumber}/orders`,

    PATH_ORDER_DETAIL: '/:customer_id/order/:id',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PATH_ORDER_DETAIL_TO: (id: string | number) => `/${customerNumber}/order/${id}`,

    PATH_NEW_ORDER: '/:customer_id/order/new',
    PATH_NEW_ORDER_TO: `/${customerNumber}/order/new`,
  };
};
